<template lang="pug">
h1 Ups! algo salio mal
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
